:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

.editor-layout-editing-area.truncated ._previewContainer_vqc7o_7 {
  overflow-y: hidden; }

.editor-layout-editing-area.fixed ._previewContainer_vqc7o_7 {
  margin-left: var(--stage-left-margin);
  overflow-x: hidden; }
  .editor-layout-editing-area.fixed ._previewContainer_vqc7o_7 ._previewPlaceholder_vqc7o_13 {
    width: var(--stage-fixed-width); }

.editor-layout-editing-area.horizontallyScrollable ._previewContainer_vqc7o_7 {
  height: calc(100% - var(--stage-scrollbar-width));
  left: var(--stage-left-margin); }
  .editor-layout-editing-area.horizontallyScrollable ._previewContainer_vqc7o_7 ._previewPlaceholder_vqc7o_13 {
    max-width: var(--stage-fixed-width); }

.editing-area.mobile-editor .preview-frame-cover.mobile-wizard-preview-frame ._previewContainer_vqc7o_7 {
  overflow: hidden; }

.editing-area ._previewContainer_vqc7o_7 {
  -webkit-user-select: none;
  user-select: none;
  overflow-y: scroll;
  position: relative;
  width: 100%;
  height: 100%; }
  .editing-area ._previewContainer_vqc7o_7 ._mobileHidePreviewLeft_vqc7o_34,
  .editing-area ._previewContainer_vqc7o_7 ._mobileHidePreviewRight_vqc7o_35 {
    display: block;
    position: absolute;
    top: 0;
    height: 100%; }
  .editing-area ._previewContainer_vqc7o_7 ._mobileHidePreviewLeft_vqc7o_34 {
    left: 0; }

.editing-area .resizable-preview-mode ._previewContainer_vqc7o_7 {
  margin: 0 var(--preview-horizontal-margin);
  flex-shrink: 0;
  width: var(--preview-width);
  box-shadow: 0px 12px 20px 0px rgba(23, 25, 28, 0.12); }
  .editing-area .resizable-preview-mode ._previewContainer_vqc7o_7 ._previewPlaceholder_vqc7o_13 {
    width: var(--preview-width); }

.editing-area .resizable-preview-mode.mobile-editor ._previewContainer_vqc7o_7 {
  box-shadow: none;
  width: 100%;
  animation: _fade-in_vqc7o_1 linear 0.4s;
  transition: none; }
  .editing-area .resizable-preview-mode.mobile-editor ._previewContainer_vqc7o_7 ._previewPlaceholder_vqc7o_13 {
    width: 100%; }

.editing-area.preview-resize-animation ._previewContainer_vqc7o_7 {
  transition: width 0.33s cubic-bezier(0.45, 0, 0.55, 1), margin 0.33s cubic-bezier(0.45, 0, 0.55, 1), height 0.33s cubic-bezier(0.45, 0, 0.55, 1); }

.editing-area.preview-resize-animation ._previewPlaceholder_vqc7o_13 {
  transition: width 0.33s cubic-bezier(0.45, 0, 0.55, 1), height 0.33s cubic-bezier(0.45, 0, 0.55, 1); }

.editing-area.preview-mode ._previewContainer_vqc7o_7 {
  overflow: hidden; }

._previewPlaceholder_vqc7o_13 {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  border: 0;
  overflow: hidden; }
